import React from 'react';
import { createPortal } from 'react-dom';
import { X, Save, RefreshCw } from 'lucide-react';
import SearchBar from '../../../components/SearchBar';
import { text } from '../constants/configurationText';
import DotCheckbox from './DotCheckbox';

const AssignAdminModal = ({
  theme,
  styles,
  t = text.en,
  selectedCompany,
  adminCandidates,
  selectedAdminIds,
  adminSearch,
  loadingAdmins,
  setAdminSearch,
  onToggleAdmin,
  onSave,
  onClose,
}) => {
  return createPortal(
    <div style={styles.modal} onClick={onClose}>
      <div className="cfg-modal" style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <div style={styles.modalHeader}>
          <h3 style={styles.modalTitle}>{t.assignTitle(selectedCompany)}</h3>
          <button style={styles.closeButton} onClick={onClose} aria-label={t.close}>
            <X size={18} />
          </button>
        </div>

        <div style={{ marginBottom: '16px' }}>
          <SearchBar
            value={adminSearch}
            onChange={setAdminSearch}
            placeholder={t.searchEmployees}
            theme={theme === 'light' ? 'light' : 'dark'}
            language={t.lang}
            icon
          />
        </div>

        {loadingAdmins ? (
          <div style={{
            textAlign: "center",
            padding: "40px",
            color: theme === "light" ? "#64748b" : "rgba(255, 255, 255, 0.6)",
          }}>
            <RefreshCw size={32} style={{ animation: 'spin 1s linear infinite', marginBottom: '12px' }} />
            <p>{t.loadingEmployees}</p>
          </div>
        ) : (
          <div style={{
            maxHeight: "50vh",
            overflowY: "auto",
            padding: "8px",
            background: styles.colors.softBg,
            border: `1px solid ${styles.colors.border}`,
            borderRadius: "12px",
          }}>
            {adminCandidates
              .filter(emp => !adminSearch || emp.sr.toLowerCase().includes(adminSearch.toLowerCase()))
              .map(emp => (
                <label
                  key={emp.infinityCode}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",
                    padding: "10px 12px",
                    cursor: "pointer",
                    borderRadius: "8px",
                    transition: "background 0.2s",
                  }}
                  onMouseEnter={(e) =>
                    e.currentTarget.style.background =
                      theme === "dark" ? "rgba(148,163,184,0.08)" : "rgba(15,23,42,0.03)"
                  }
                  onMouseLeave={(e) =>
                    e.currentTarget.style.background = "transparent"
                  }
                >
                  <DotCheckbox
                    checked={selectedAdminIds.includes(emp.infinityCode)}
                    onChange={() => onToggleAdmin(emp.infinityCode)}
                    theme={theme}
                  />
                  <span style={{ fontSize: "14px", color: theme === "light" ? "#0f172a" : "#ffffff" }}>
                    {emp.sr}
                  </span>
                </label>
              ))}

            {adminCandidates.filter(emp =>
              !adminSearch || emp.sr.toLowerCase().includes(adminSearch.toLowerCase())
            ).length === 0 && (
              <p style={{
                textAlign: "center",
                color: theme === "light" ? "#64748b" : "rgba(255, 255, 255, 0.6)",
              }}>
                {t.noEmployees}
              </p>
            )}
          </div>
        )}

        <div style={styles.modalButtons}>
          <button className="cfg-btn-secondary" style={styles.btnSecondary()} onClick={onClose}>
            {t.cancel}
          </button>
          <button
            className="cfg-btn-primary"
            style={styles.btnPrimary(loadingAdmins || selectedAdminIds.length === 0)}
            onClick={() => onSave(selectedCompany)}
            disabled={loadingAdmins || selectedAdminIds.length === 0}
          >
            {loadingAdmins ? (
              <>
                <RefreshCw size={16} style={{ animation: 'spin 1s linear infinite' }} />
                {t.saving}
              </>
            ) : (
              <>
                <Save size={16} />
                {t.assignN(selectedAdminIds.length)}
              </>
            )}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default AssignAdminModal;